export default {
    Zero: 0,
    One: 1,
    Two: 2,
    Three: 3,
    Hundred: 100,
    Thousand: 1000,
    KB: 1024
};
